import './NavMenuOption.css';
import osImage from './money.png';
import osImageBlack from './money-black.png';
import userImage from './group.png';
import userImageBlack from './group-black.png';
import selosImage from './stamp.png';
import selosImageBlack from './stamp-black.png';
import graphImage from './graph.png';
import graphImageBlack from './graph-black.png';
import { INavMenuRoute } from '../../HeaderOptions';
import {INavMenuOption } from '../../../hooks/useHeaderOptions';
import { useIconColor } from '../../../hooks/useIconsColor';



export default function NavMenuOption(props: INavMenuOption)
{
   
    return(
        <div className='NavMenuOption'
            onClick={()=>{ window.location.pathname=`${props.URL}`}}>
                {props.Image}
                <div>
                    <h3>{props.Title}</h3>
                    <p className='MenuOptionSubtitle'>{props.SubTitle}</p>
                </div>                
            </div>
    )
}